<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>警报点详情</el-breadcrumb-item>
        <el-breadcrumb-item>历史记录查询</el-breadcrumb-item>
        <el-breadcrumb-item>静态信息修改记录</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <div class="handle_box">
        <!--查询盒子-->
        <el-select v-model="GetStaticInformationRecordList.params.option" placeholder="修改的表单" filterable clearable>
          <el-option :value="1" label="警报器信息" ></el-option>
          <el-option :value="2" label="警报控制器信息" ></el-option>
          <el-option :value="3" label="物联网监测终端信息" ></el-option>
        </el-select>
        <el-date-picker style="margin-left: 15px"
                        v-model="dateRange"
                        type="datetimerange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
        <el-button type="primary" style="margin-top: 40px; margin-left: 20px;" icon="el-icon-search" @click="getStaticInformationRecordList">查询</el-button>
      </div>
      <el-table style="margin-top: 20px; font-size: 14px;" :data="StaticInformationRecordList.result.staticInformationRecordList.length<10? StaticInformationRecordList.result.staticInformationRecordList: StaticInformationRecordList.result.staticInformationRecordList.slice((currentPage-1)*10, currentPage*10)" height="350">
        <el-table-column label="序号" type="index" ></el-table-column>
        <el-table-column label="修改的表单" prop="option" width="200px">
          <template slot-scope="scope">
            <el-tag>{{getOptionName(scope.row.option)}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="修改时间" prop="altTime" width="auto">
          {{chosenOption}}<br>
          {{chosenContent}}
          <template slot-scope="scope">
            <i class="el-icon-time"></i>
            <span>&nbsp;{{scope.row.altTime}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="230" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="altDetailView(scope.row.option, scope.row.content)">查看修改详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          @current-change="getStaticInformationRecordList"
          background
          layout="prev, pager, next"
          :page-size="10"
          :total="TotalCount*10"
          :current-page.sync="GetStaticInformationRecordList.params.pageNumber">
        </el-pagination>
      </div>
    </el-card>
    <el-dialog :visible.sync="detailVisible" @close="detailVisible = false" title="修改详情" v-if="detailVisible">
      <!--{{chosenOption}}{{chosenContent}}-->
      <div v-show="chosenOption === 1">
        <el-form inline class="demo-table-expand" :label-position="labelPosition">
          <el-form-item label="生产厂家">
            <span>{{chosenContent.producer}}</span>
          </el-form-item>
          <el-form-item label="设备型号">
            <span>{{chosenContent.type}}</span>
          </el-form-item>
          <el-form-item label="版本">
            <span>{{chosenContent.version}}</span>
          </el-form-item>
          <el-form-item label="功率">
            <span>{{chosenContent.power}}</span>
          </el-form-item>
          <el-form-item label="安装者">
            <span>{{chosenContent.installer}}</span>
          </el-form-item>
          <el-form-item label="安装时间">
            <span><i class="el-icon-time"></i>  {{chosenContent.installAt}}</span>
          </el-form-item>
          <el-form-item label="备注">
            <span>{{chosenContent.remark}}</span>
          </el-form-item>
        </el-form>
      </div>
      <div v-show="chosenOption === 2">
        <el-form inline class="demo-table-expand" :label-position="labelPosition">
          <el-form-item label="生产厂家">
            <span>{{chosenContent.producer}}</span>
          </el-form-item>
          <el-form-item label="通信体制">
            <span>{{chosenContent.communicationSystem}}</span>
          </el-form-item>
          <el-form-item label="版本">
            <span>{{chosenContent.version}}</span>
          </el-form-item>
          <el-form-item label="地址码">
            <span>{{chosenContent.addressCode}}</span>
          </el-form-item>
          <el-form-item label="电台型号">
            <span>{{chosenContent.radioType}}</span>
          </el-form-item>
          <el-form-item label="安装者">
            <span>{{chosenContent.installer}}</span>
          </el-form-item>
          <el-form-item label="安装时间">
            <span><i class="el-icon-time"></i> &nbsp;{{chosenContent.installAt}}</span>
          </el-form-item>
          <br>
          <el-form-item label="备注">
            <span>{{chosenContent.remark}}</span>
          </el-form-item>
        </el-form>
      </div>
      <div v-show="chosenOption === 3">
        <el-form inline class="demo-table-expand" :label-position="labelPosition">
          <el-form-item label="生产厂家">
            <span>{{chosenContent.producer}}</span>
          </el-form-item>
          <el-form-item label="安装者">
            <span>{{chosenContent.installer}}</span>
          </el-form-item>
          <el-form-item label="设备型号">
            <span>{{chosenContent.type}}</span>
          </el-form-item>
          <el-form-item label="物联卡号">
            <span>{{chosenContent.ICCID}} </span>
          </el-form-item>
          <el-form-item label="安装时间">
            <span><i class="el-icon-time"></i> {{chosenContent.installAt}}</span>
          </el-form-item>
          <br>
          <el-form-item label="备注">
            <span>{{chosenContent.remark}}</span>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'StaticInformationRecordList',
  data(){
    return {
      detailVisible: false,
      chosenOption:'',
      chosenContent:'',
      currentPage:1,
      TotalCount:'',
      dateRange:'',// 时间范围
      addInspectRecordDialogVisible: false,// 添加巡检记录模态框是否可见
      updateInspectRecordDialogVisible: false, // 修改巡检记录模态框是否可见
      labelPosition:'left',
      // 获取警报点列表
      GetAlarmPointList:{
        "version": 1,
        "method": "alarmpoint.GetAlarmPointList",
        "params": {
          "pointName":null,
          "alarmPointType":null,
          "areaId":null
        },
        "token": "",
        "id": 0
      },
      // 警报点列表
      alarmPointList:{
        "version": 1,
        "result":{
          "alarmPointList": [
            {
              "alarmPointId":  "",
              "pointName": "",
              "alarmPointType": "",
              "longitude": "",
              "latitude": "",
              "alarmRadius":"",
              "areaId":"",
              "installAt":"",
              "remark":""
            },
          ]
        },
        "id": 0
      },
      // 获取静态修改记录
      GetStaticInformationRecordList:{
        "version": 1,
        "method": "alarmpoint2.GetStaticInformationRecordList",
        "params": {
          "pageNumber":1,
          "alarmPointId":"",
          "option":"",
          "startTime":"",
          "endTime":""
        },
        "token": "",
        "id": 0
      },
      // 静态修改列表
      StaticInformationRecordList:{
        "version": 1,
        "result":{
          staticInformationRecordList:[{
            "alarmPointId":"",
            "option":"",
            "altTime":"",
            "content":""
          }],
        },
        "id": 0
      }
    }
  },
  methods: {
    altDetailView(option, content){
      this.chosenOption = option;
      this.chosenContent = content;
      console.log('option');
      console.log(this.chosenOption);
      console.log('content');
      console.log(this.chosenContent);
      this.detailVisible = true;
    },
    getOptionName(option){
      let name = '';
      switch (option) {
        case 1: name = "警报器信息";break;
        case 2: name = "警报控制器信息";break;
        case 3: name = "物联网监测终端信息";break;
        default: break;
      }
      return name;
    },
    handleCurrentChange(currentPage){
      this.currentPage = currentPage;
    },
    // 获取警报点列表
    getAlarmPointList(){
      for (let val in this.GetAlarmPointList.params){
        if(this.GetAlarmPointList.params[val] === ""){
          this.GetAlarmPointList.params[val] = null;
        }
      }
      if(this.GetAlarmPointList.params.areaId !== null){
        this.GetAlarmPointList.params.areaId = this.GetAlarmPointList.params.areaId[this.GetAlarmPointList.params.areaId.length-1];
      }
      this.GetAlarmPointList.token = localStorage.getItem('token');
      console.log('获取警报点列表请求');
      console.log(this.GetAlarmPointList);
      this.$axios.post(this.$mainUrl, this.GetAlarmPointList).then(res=>{
        console.log('获取警报点列表请求得到响应');
        console.log(res.data);
        this.alarmPointList = res.data;
      })
    },
    // 获取警报点静态信息修改记录
    getStaticInformationRecordList(){
      this.GetStaticInformationRecordList.params.alarmPointId = sessionStorage.getItem('alarmPointId');
      for (let key in this.GetStaticInformationRecordList.params){
        if(this.GetStaticInformationRecordList.params[key] === ""){
          this.GetStaticInformationRecordList.params[key] = null;
        }
      }
      this.GetStaticInformationRecordList.token = localStorage.getItem('token');
      console.log('获取警报点静态信息请求');
      console.log(this.GetStaticInformationRecordList);
      this.$axios.post(this.$mainUrl, this.GetStaticInformationRecordList).then(res=>{
        console.log('获取警报点静态信息请求得到响应');
        console.log(res.data);
        if(res.data.hasOwnProperty('result')){
          this.$message({
            type:'success',
            message: '获取警报点静态信息成功',
          })
          this.StaticInformationRecordList = res.data;
          this.TotalCount = res.data.result.page;
        }else{
          this.$message({
            type:'error',
            message: '获取警报点静态信息失败,' + res.data.error.message,
          })
        }
      })
    }

  },
  watch:{
    dateRange(newValue, oldValue){
      this.GetStaticInformationRecordList.params.startTime = newValue[0];
      this.GetStaticInformationRecordList.params.endTime = newValue[1];
    }
  },
  mounted(){
    this.getStaticInformationRecordList();
  }
}
</script>

<style scoped>
  .handle_input{
    width: 200px;
    height: 16px;
    margin-left: 20px;
    display: inline-block;

  }
  .handle_select{
    width: 120px;
    margin-left: 20px;
    display: inline-block;
  }
  .handle_date_picker{
    width: 150px;
    margin-left: 20px;
    display: inline-block;
  }
  .handle_box{
    margin-top: -30px;
  }
  .addButton{
    text-align: left;
    margin-top: 20px;
    position: relative;
    float: left;
  }
  .pagination{
    position: relative;
    float: right;
    margin-top: 20px;
    text-align: right;
  }
</style>
<style>
  .demo-table-expand {
    font-size: 0;
  }
  .demo-table-expand label {
    width: 90px;
    color: #99a9bf;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
  }
</style>

